import {
    SEND_LOAN_OFFICER_VERIFY_EMAIL_OTP,
    CONFIRM_LOAN_OFFICER_EMAIL_OTP,
    UPDATE_LOAN_OFFICER_DATA,
    LOAN_OFFICER_LOGIN,
    FORGOT_LOAN_OFFICER_PASSWORD,
    GET_LOAN_OFFICER_INFORMATION_BY_LOAN_OFFICER_ID,
    GET_LOAN_OFFICER_DASHBOARD_SUMMARY,
    GET_APPLICATION_REVIEW_COMMENT_FOR_LOAN_OFFICER,
    GET_REVIST_APPLICATION_LIST_BY_LOANOFFICER_ID,
    CHANGE_LOAN_OFFICER_PASSWORD,
    GET_ALL_LOAN_APPLICATION_LIST_BY_LOAN_OFFICER_ID,
    GET_USER_MANAGEMENT_DATA,
} from "../constants/constants";
import { instance } from "./apiRequest";

let _LoanOfficerService = {
    async sendLoanOfficerVerifyEmailOTP(obj) {
        return await instance.post(SEND_LOAN_OFFICER_VERIFY_EMAIL_OTP, obj);
    },
    async confirmLoanOfficerEmailOTP(obj) {
        return await instance.post(CONFIRM_LOAN_OFFICER_EMAIL_OTP, obj);
    },
    async updateLoanOfficerData(reqObj) {
        return await instance.post(UPDATE_LOAN_OFFICER_DATA, reqObj);
    },
    async loanOfficerLogin(obj) {
        return await instance.post(LOAN_OFFICER_LOGIN, obj);
    },
    async forgotLoanOfficerPassword(reqObj) {
        return await instance.post(FORGOT_LOAN_OFFICER_PASSWORD, reqObj);
    },
    async getLoanOfficerInformationByLoanOfficerId(loanOfficerId) {
        return await instance.post(GET_LOAN_OFFICER_INFORMATION_BY_LOAN_OFFICER_ID, { loanOfficerId: loanOfficerId });
    },
    async getUserManagementData(emailId, roleId, bankAdminId) {
        return await instance.post(GET_USER_MANAGEMENT_DATA, { email: emailId, roleId: roleId, bankAdminId: bankAdminId });
    },
    async getLoanOfficerDashboardSummary(loanOfficerId) {
        return await instance.post(GET_LOAN_OFFICER_DASHBOARD_SUMMARY, { loanOfficerId: loanOfficerId });
    },
    async getApplicationReviewCommentForLoanOfficer(applicationId, loanOfficerId) {
        return await instance.post(GET_APPLICATION_REVIEW_COMMENT_FOR_LOAN_OFFICER, { applicationId: applicationId, loanOfficerId: loanOfficerId });
    },
    async getRevistApplicationListByLoanOfficerId({ LoanOfficerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        return await instance.post(GET_REVIST_APPLICATION_LIST_BY_LOANOFFICER_ID, { id: LoanOfficerId, startDate: startDate, endDate: endDate, pageIndex: pageIndex, pageSize: pageSize, searchTerm: searchTerm, sortBy: sortBy, sortAsc: sortAsc });
    },
    async ChangeLoanOfficerPassword(reqObj) {
        return await instance.post(CHANGE_LOAN_OFFICER_PASSWORD, reqObj);
    },
    async getAllLoanApplicationListByLoanOfficerId({
        loanOfficerId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let body = {
            id: loanOfficerId,
            pageIndex: pageIndex,
            pageSize: pageSize,
            byAppStatus: appStatus,
        };

        if (searchTerm && searchTerm != "") {
            body.searchTerm = searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            body.startDate = startDate;
            body.endDate = endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            body.sortBy = sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            body.sortAsc = sortBytext;
        }
        return await instance.post(GET_ALL_LOAN_APPLICATION_LIST_BY_LOAN_OFFICER_ID, body);
    },
}
export default _LoanOfficerService;